import React from "react";
import Icon_Error from "assets/Icon_Warning.png";

const ErrorFallback: React.FC<{ narrow?: boolean }> = ({ narrow }) => {
  return (
    <div className="ErrorPage">
      <div className="ErrorCell">
        <div className="Img">
          <img src={Icon_Error} alt="Error" />
        </div>
        {!narrow && (
          <div className="Txt">
            <h2>Something went wrong</h2>
            <p>
              Please try again. If the error persists, please contact <a href={"mailto: support@servicemonitor.co.uk"}>support@servicemonitor.co.uk</a>.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
